<aside class="aside" [ngClass]="[_cs.slideOpen ? 'iconn-bar-width-class' : 'nor-bar-width', _cs.expandMenu ? 'expand-menu' : '' ]">
    <div class="logo-row">
      <!-- <div class="logo-img" [ngClass]="{'transition-none': _cs.slideOpen}">
          <img src="assets/images/Eatec-Logo.png" alt="thumb-eatec">
      </div>
      <div class="logo-icon" [ngClass]="{'menu-toogle': _cs.slideOpen}">
         <i (click)="slide()" class="icon-path"></i>
         <i (click)="closemenu()" class="icon-requisition-denied"></i>
      </div> -->
    <div>
        <span class="circle-section">{{userAbbreviation}}</span>
    </div>
    <div class="data-section">
        <span class="name" matTooltipClass="tooltip1" [matTooltip]="userName" (click)="tooltip1.toggle()" #tooltip1="matTooltip"
            matTooltipPosition="below">{{userName}}</span> 
        <span class="email" matTooltipClass="tooltip2"  [matTooltip]="userEmail" (click)="tooltip2.toggle()" #tooltip2="matTooltip"
        matTooltipPosition="below">{{userEmail}}</span>
    </div>
    </div>
    <app-navbar class="aside-nav"></app-navbar>
</aside>
